import { createContext } from 'react';

export type ThemePreference = 'light' | 'dark' | 'system';

interface ThemeContext {
  // Tema resolvido aplicado de fato ('system' já vira light/dark).
  themeType: 'light' | 'dark';
  // Escolha persistida do usuário.
  themePreference: ThemePreference;
  setTheme: (theme: ThemePreference) => void;
}

export const ThemeToggleContext = createContext<ThemeContext>({
  themeType: 'light',
  themePreference: 'light',
  setTheme: () => {},
});
